import { storageService } from '../async-storage.service'
import { utilService } from '../util.service'

const STORAGE_KEY = 'comments'

export const commentService = {
  query,
  getById,
  save,
  remove,
}

// Query comments based on filters
async function query(filterBy = {}) {
  const comments = await storageService.query(STORAGE_KEY)
  return comments.filter((comment) => {
    const matchesPost = !filterBy.postId || comment.postId === filterBy.postId
    const matchesUser =
      !filterBy.userId || comment.author.userId === filterBy.userId
    return matchesPost && matchesUser
  })
}

// Get a specific comment by its ID
async function getById(commentId) {
  return await storageService.get(STORAGE_KEY, commentId)
}

// Save or update a comment
async function save(comment) {
  if (comment._id) {
    return await storageService.put(STORAGE_KEY, comment)
  } else {
    comment._id = utilService.makeId()
    return await storageService.post(STORAGE_KEY, comment)
  }
}

// Remove a comment by its ID
async function remove(commentId) {
  return await storageService.remove(STORAGE_KEY, commentId)
}
